import { GlobalErrorHandlerService } from '@vmspdb/ui/common';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function handleOptionsError<T>(errors: GlobalErrorHandlerService) {
  return (source: Observable<T>) =>
    source.pipe(
      catchError((err) => {
        errors.reportCaughtError(err);
        return of([]);
      }),
    );
}
